export function fmt(d) {
  return d ? new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';
}

export function fmtCurrency(v) {
  return v != null ? '£' + Number(v).toLocaleString() : '—';
}

export function stageBadgeClass(name) {
  const map = { Initiate: 'pu', Define: 'pu', Design: 'pu', Build: 'am', Test: 'am', Deploy: 'tl', Embed: 'gr' };
  return map[name] || '';
}

export function statusBadgeClass(name) {
  const map = { Active: 'gr', Draft: '', 'On Hold': 'am', Closed: 'rd' };
  return map[name] || '';
}

export function priorityBadgeClass(p) {
  const map = { critical: 'rd', high: 'am', medium: '', low: 'tl' };
  return map[p] || '';
}

export const inhColors = {
  inherited:  { bg: '#e1f5ee', color: '#085041' },
  extended:   { bg: '#eeedfe', color: '#3c3489' },
  overridden: { bg: '#faeeda', color: '#854f0b' },
  new:        { bg: '#E6F1FB', color: '#0C447C' },
};

export const raidTypeStyle = {
  risk:       'background:#FCEBEB;color:#A32D2D',
  issue:      'background:#FCEBEB;color:#A32D2D',
  assumption: 'background:#FAEEDA;color:#854F0B',
  dependency: 'background:#E6F1FB;color:#0C447C',
};
